// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"ButtonStoreOnLocalDrive_inputRoot__3Esbm","inputWrapper":"ButtonStoreOnLocalDrive_inputWrapper__OW7Yf","icon":"ButtonStoreOnLocalDrive_icon__2NwWj"};